import { FvButton } from '@fv/client-components'
import type { PropsWithClassName } from '@fv/client-types'

import InfoBox from '@/components/InfoBox'
import { useUnCancelLoad } from '@/hooks/shipments'

type Props = PropsWithClassName & {
  onClose: () => void
  loadId: string
}

export const UnCancelShipmentPrompt = ({
  className,
  onClose,
  loadId,
}: Props) => {
  const unCancelLoad = useUnCancelLoad(loadId)

  const handleConfirm = async () => {
    await unCancelLoad.mutateAsync()
    onClose()
  }

  const handleDecline = () => {
    onClose()
  }

  return (
    <div className={className}>
      <InfoBox className="mb-6">
        <p className="mb-0">
          Warning: After you uncancel this shipment you will need to contact the
          carrier to ensure the shipment is no longer canceled in their systems.
        </p>
      </InfoBox>

      <div className="flex--justify-items-e mb-2 flex">
        <FvButton
          loading={unCancelLoad.isPending}
          onClick={handleConfirm}
          theme="primary"
          icon="check"
        >
          Yes, uncancel
        </FvButton>
        <FvButton
          loading={unCancelLoad.isPending}
          onClick={handleDecline}
          theme="default"
          icon="times"
        >
          No
        </FvButton>
      </div>
    </div>
  )
}
